export default __webpack_public_path__ + "static/media/maxresdefault.eab9317a.jpg";